var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NormalImg1_inner",style:(_vm.NormalImg1_inner_height)},[_c('img',{attrs:{"src":this.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }